import type { paths } from '@luxuryescapes/contract-svc-lux-loyalty'

type EsimOrderResult =
  paths['/api/lux-loyalty/esim/orders']['get']['responses']['200']['content']['application/json']['result']['orders'][number]

type EsimPromoCodeResult =
  paths['/api/lux-loyalty/esim/order/{orderId}']['get']['responses']['200']['content']['application/json']['result']

type OrderDetailsEsimBenefit =
  paths['/api/lux-loyalty/customer/{customerId}/order/{orderId}']['get']['responses']['200']['content']['application/json']['result']['esimBenefit']

export function mapLoyaltyEsimBenefit(benefit: EsimOrderResult): App.LoyaltyEsimBenefit {
  return {
    orderId: benefit.orderId,
    customerId: benefit.customerId,
    countryCodes: benefit.countryCodes,
    tier: benefit.tier,
    packageSizeGB: benefit.packageSizeGB,
    packageSize: benefit.packageSize,
    unlimitedDays: benefit.unlimitedDays,
    status: benefit.status,
    departureDate: benefit.departureDate,
    endDate: benefit.endDate,
    promocode: benefit.promocode,
    partner: benefit.partner,
  }
}

export function mapLoyaltyEsimPromoCode(result: EsimPromoCodeResult): App.LoyaltyEsimBenefit {
  return mapLoyaltyEsimBenefit(result)
}

export function mapOrderLoyaltyEsimBenefit(
  benefit: NonNullable<OrderDetailsEsimBenefit>,
): App.OrderLoyaltyEsimBenefit {
  return {
    packageSize: benefit.packageSize,
    tier: benefit.tier,
    packageSizeGB: benefit.packageSizeGB,
    unlimitedDays: benefit.unlimitedDays,
    status: benefit.status,
    countryCodes: benefit.countryCodes,
    departureDate: benefit.departureDate,
    endDate: benefit.endDate,
  }
}

export function mapLoyaltyEsimBenefitToOrderEsimBenefit(
  benefit: App.LoyaltyEsimBenefit,
): App.OrderLoyaltyEsimBenefit {
  return {
    packageSize: benefit.packageSize,
    tier: benefit.tier,
    packageSizeGB: benefit.packageSizeGB,
    unlimitedDays: benefit.unlimitedDays,
    status: benefit.status,
    countryCodes: benefit.countryCodes,
    departureDate: benefit.departureDate,
    endDate: benefit.endDate,
  }
}
